"use client";

import {Moon, Sun} from "lucide-react";
import {useTheme} from "next-themes";

export function ThemeToggle() {
  const {resolvedTheme, setTheme} = useTheme();

  return (
    <button
      type="button"
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
      aria-label="Switch between light and dark mode"
      title="Switch between light and dark mode"
      className="group-theme-toggle grid h-11 w-11 shrink-0 place-items-center rounded-full border transition hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--group-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--group-bg)]"
    >
      <Moon className="h-[1.1rem] w-[1.1rem] dark:hidden" aria-hidden />
      <Sun className="hidden h-[1.1rem] w-[1.1rem] dark:block" aria-hidden />
    </button>
  );
}
